import { CheckCircle2, ShieldAlert, XCircle } from "lucide-react"

import { useToast } from "@/hooks/use-toast"
import { toastKind } from "@/lib/toastKind"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

const ICONS = {
  success: CheckCircle2,
  destructive: XCircle,
  blocked: ShieldAlert,
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider swipeDirection="up">
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const kind = toastKind({ variant, title })
        const Icon = ICONS[kind]
        return (
          <Toast key={id} variant={kind} data-toast-kind={kind} {...props}>
            {Icon && <Icon className="h-5 w-5 shrink-0" aria-hidden="true" />}
            <div className="grid flex-1 gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
